@use 'nhsuk-frontend/core' as *;
@use 'nhsuk-frontend/components/footer' as *;